var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        staticClass: "page"
    }, [
        _vm._m(0),
        _c('van-form', {
            ref: "informationRef",
            on: {
                "submit": _setup.onSubmit,
                "failed": _setup.onFailed
            }
        }, [
            _c('div', {
                staticClass: "form-box"
            }, [
                _c('div', {
                    staticClass: "form-title"
                }, [
                    _vm._v("Información personal")
                ]),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textEducation ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Antecedentes educativos")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "learningPath",
                            "value": _setup.textEducation,
                            "label": "",
                            "placeholder": "Antecedentes educativos",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Antecedentes educativos'
                                }
                            ],
                            "right-icon": _setup.showPickerEducation ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerEducation
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Antecedentes educativos',
                            "columns": _setup.columnsEducation,
                            "selection": _setup.codeEducation
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerEducation = false;
                            },
                            "confirm": _setup.onConfirmEducation
                        },
                        model: {
                            value: _setup.showPickerEducation,
                            callback: function callback($$v) {
                                _setup.showPickerEducation = $$v;
                            },
                            expression: "showPickerEducation"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textMarry ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Estado civil")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "relationshipState",
                            "value": _setup.textMarry,
                            "label": "",
                            "placeholder": "Estado civil",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Estado civil'
                                }
                            ],
                            "right-icon": _setup.showPickerMarry ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerMarry
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Estado civil',
                            "columns": _setup.columnsMarry,
                            "selection": _setup.codeMarry
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerMarry = false;
                            },
                            "confirm": _setup.onConfirmMarry
                        },
                        model: {
                            value: _setup.showPickerMarry,
                            callback: function callback($$v) {
                                _setup.showPickerMarry = $$v;
                            },
                            expression: "showPickerMarry"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textState ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Estado")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "regionCode",
                            "value": _setup.textState,
                            "label": "",
                            "placeholder": "Estado",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Estado'
                                }
                            ],
                            "right-icon": _setup.showPickerState ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerState
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Estado',
                            "columns": _setup.columnsState,
                            "selection": _setup.codeState
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerState = false;
                            },
                            "confirm": _setup.onConfirmState
                        },
                        model: {
                            value: _setup.showPickerState,
                            callback: function callback($$v) {
                                _setup.showPickerState = $$v;
                            },
                            expression: "showPickerState"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textCity ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Ciudad")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "urbanCode",
                            "value": _setup.textCity,
                            "label": "",
                            "placeholder": "Ciudad",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Ciudad'
                                }
                            ],
                            "right-icon": _setup.showPickerCity ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerCity
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Ciudad',
                            "columns": _setup.columnsCity,
                            "selection": _setup.codeCity
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerCity = false;
                            },
                            "confirm": _setup.onConfirmCity
                        },
                        model: {
                            value: _setup.showPickerCity,
                            callback: function callback($$v) {
                                _setup.showPickerCity = $$v;
                            },
                            expression: "showPickerCity"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textLiveDuration ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Duración de la estancia")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "stayPeriod",
                            "value": _setup.textLiveDuration,
                            "label": "",
                            "placeholder": "Duración de la estancia",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Duración de la estancia'
                                }
                            ],
                            "right-icon": _setup.showPickerLiveDuration ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerLiveDuration
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Duración de la estancia',
                            "columns": _setup.columnsLiveDuration,
                            "selection": _setup.codeLiveDuration
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerLiveDuration = false;
                            },
                            "confirm": _setup.onConfirmLiveDuration
                        },
                        model: {
                            value: _setup.showPickerLiveDuration,
                            callback: function callback($$v) {
                                _setup.showPickerLiveDuration = $$v;
                            },
                            expression: "showPickerLiveDuration"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.address ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Dirección detallada de residencia")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "placeInfo",
                            "clearable": "",
                            "placeholder": "Dirección detallada de residencia",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Dirección detallada de residencia'
                                }
                            ]
                        },
                        on: {
                            "focus": function($event) {
                                return _setup.onFocusTrack('address');
                            },
                            "blur": function($event) {
                                return _setup.onBlurTrack('address');
                            }
                        },
                        model: {
                            value: _setup.address,
                            callback: function callback($$v) {
                                _setup.address = $$v;
                            },
                            expression: "address"
                        }
                    })
                ], 1)
            ]),
            _c('div', {
                staticClass: "form-box"
            }, [
                _c('div', {
                    staticClass: "form-title"
                }, [
                    _vm._v("Información laboral")
                ]),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textWorkType ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Tipo de empleo")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "workType",
                            "value": _setup.textWorkType,
                            "label": "",
                            "placeholder": "Tipo de empleo",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Tipo de empleo'
                                }
                            ],
                            "right-icon": _setup.showPickerWorkType ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerWorkType
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Tipo de empleo',
                            "columns": _setup.columnsWorkType,
                            "selection": _setup.codeWorkType
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerWorkType = false;
                            },
                            "confirm": _setup.onConfirmWorkType
                        },
                        model: {
                            value: _setup.showPickerWorkType,
                            callback: function callback($$v) {
                                _setup.showPickerWorkType = $$v;
                            },
                            expression: "showPickerWorkType"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textIndustry ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Tipo de industria")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "jobRole",
                            "value": _setup.textIndustry,
                            "label": "",
                            "placeholder": "Tipo de industria",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Tipo de industria'
                                }
                            ],
                            "right-icon": _setup.showPickerIndustry ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerIndustry
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Tipo de industria',
                            "columns": _setup.columnsIndustry,
                            "selection": _setup.codeIndustry
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerIndustry = false;
                            },
                            "confirm": _setup.onConfirmIndustry
                        },
                        model: {
                            value: _setup.showPickerIndustry,
                            callback: function callback($$v) {
                                _setup.showPickerIndustry = $$v;
                            },
                            expression: "showPickerIndustry"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textJobType ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Puestos de trabajo")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "workRole",
                            "value": _setup.textJobType,
                            "label": "",
                            "placeholder": "Puestos de trabajo",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Puestos de trabajo'
                                }
                            ],
                            "right-icon": _setup.showPickerJobType ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerJobType
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Puestos de trabajo',
                            "columns": _setup.columnsJobType,
                            "selection": _setup.codeJobType
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerJobType = false;
                            },
                            "confirm": _setup.onConfirmJobType
                        },
                        model: {
                            value: _setup.showPickerJobType,
                            callback: function callback($$v) {
                                _setup.showPickerJobType = $$v;
                            },
                            expression: "showPickerJobType"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textWorkDuration ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Duracion de trabajo")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "jobSpan",
                            "value": _setup.textWorkDuration,
                            "label": "",
                            "placeholder": "Duracion de trabajo",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Duracion de trabajo'
                                }
                            ],
                            "right-icon": _setup.showPickerWorkDuration ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerWorkDuration
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Duracion de trabajo',
                            "columns": _setup.columnsWorkDuration,
                            "selection": _setup.codeWorkDuration
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerWorkDuration = false;
                            },
                            "confirm": _setup.onConfirmWorkDuration
                        },
                        model: {
                            value: _setup.showPickerWorkDuration,
                            callback: function callback($$v) {
                                _setup.showPickerWorkDuration = $$v;
                            },
                            expression: "showPickerWorkDuration"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textIncomeSource ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Fuente de ingresos")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "revenueStream",
                            "value": _setup.textIncomeSource,
                            "label": "",
                            "placeholder": "Fuente de ingresos",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Fuente de ingresos'
                                }
                            ],
                            "right-icon": _setup.showPickerIncomeSource ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerIncomeSource
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Fuente de ingresos',
                            "columns": _setup.columnsIncomeSource,
                            "selection": _setup.codeIncomeSource
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerIncomeSource = false;
                            },
                            "confirm": _setup.onConfirmIncomeSource
                        },
                        model: {
                            value: _setup.showPickerIncomeSource,
                            callback: function callback($$v) {
                                _setup.showPickerIncomeSource = $$v;
                            },
                            expression: "showPickerIncomeSource"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textSalaryPayMode ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Métodos de pago del salario")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "payPeriod",
                            "value": _setup.textSalaryPayMode,
                            "label": "",
                            "placeholder": "Métodos de pago del salario",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Métodos de pago del salario'
                                }
                            ],
                            "right-icon": _setup.showPickerSalaryPayMode ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerSalaryPayMode
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Métodos de pago del salario',
                            "columns": _setup.columnsSalaryPayMode,
                            "selection": _setup.codeSalaryPayMode
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerSalaryPayMode = false;
                            },
                            "confirm": _setup.onConfirmSalaryPayMode
                        },
                        model: {
                            value: _setup.showPickerSalaryPayMode,
                            callback: function callback($$v) {
                                _setup.showPickerSalaryPayMode = $$v;
                            },
                            expression: "showPickerSalaryPayMode"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.salaryDateList.length ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Día de pago")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "paymentSchedule",
                            "value": _setup.salaryDateList.join(','),
                            "label": "",
                            "placeholder": "Día de pago",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Día de pago'
                                }
                            ],
                            "right-icon": _setup.showPickerNextSalaryDate ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerNextSalaryDate
                        }
                    }),
                    _c('van-calendar', {
                        attrs: {
                            "type": "multiple",
                            "max-range": "4",
                            "color": "#4FC684"
                        },
                        on: {
                            "confirm": _setup.onConfirmNextSalaryDate
                        },
                        model: {
                            value: _setup.showPickerNextSalaryDate,
                            callback: function callback($$v) {
                                _setup.showPickerNextSalaryDate = $$v;
                            },
                            expression: "showPickerNextSalaryDate"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textSalary ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Ingreso mensual")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "monthPaycheck",
                            "value": _setup.textSalary,
                            "label": "",
                            "placeholder": "Ingreso mensual",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Ingreso mensual'
                                }
                            ],
                            "right-icon": _setup.showPickerSalary ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerSalary
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Ingreso mensual',
                            "columns": _setup.columnsSalary,
                            "selection": _setup.codeSalary
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerSalary = false;
                            },
                            "confirm": _setup.onConfirmSalary
                        },
                        model: {
                            value: _setup.showPickerSalary,
                            callback: function callback($$v) {
                                _setup.showPickerSalary = $$v;
                            },
                            expression: "showPickerSalary"
                        }
                    })
                ], 1)
            ]),
            _c('div', {
                staticClass: "form-box"
            }, [
                _c('div', {
                    staticClass: "form-title"
                }, [
                    _vm._v("Información de cuenta bancaria")
                ]),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textBankType ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Tipos de cuenta")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "cashMode",
                            "value": _setup.textBankType,
                            "label": "",
                            "placeholder": "Tipos de cuenta",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Tipos de cuenta'
                                }
                            ],
                            "right-icon": _setup.showPickerBankType ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerBankType
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Tipos de cuenta',
                            "columns": _setup.columnsBankType,
                            "selection": _setup.codeBankType
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerBankType = false;
                            },
                            "confirm": _setup.onConfirmBankType
                        },
                        model: {
                            value: _setup.showPickerBankType,
                            callback: function callback($$v) {
                                _setup.showPickerBankType = $$v;
                            },
                            expression: "showPickerBankType"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textBankName ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Nombre del banco")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "cashKey",
                            "value": _setup.textBankName,
                            "label": "",
                            "placeholder": "Nombre del banco",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Nombre del banco'
                                }
                            ],
                            "right-icon": _setup.showPickerBankName ? '' : 'arrow'
                        },
                        on: {
                            "click": _setup.clickPickerBankName
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Nombre del banco',
                            "columns": _setup.columnsBankName,
                            "selection": _setup.codeBankName
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerBankName = false;
                            },
                            "confirm": _setup.onConfirmBankName
                        },
                        model: {
                            value: _setup.showPickerBankName,
                            callback: function callback($$v) {
                                _setup.showPickerBankName = $$v;
                            },
                            expression: "showPickerBankName"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.bankNumber ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Número de cuenta bancaria")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "bankId",
                            "clearable": "",
                            "label": "",
                            "type": "digit",
                            "maxlength": _setup.maxlength,
                            "placeholder": "Número de cuenta bancaria",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Número de cuenta bancaria'
                                },
                                {
                                    pattern: _setup.patternBankNumber,
                                    message: 'Por favor, ingresa un número de tarjeta válido.'
                                }
                            ]
                        },
                        on: {
                            "focus": function($event) {
                                return _setup.onFocusTrack('bank_account_number');
                            },
                            "blur": function($event) {
                                return _setup.onBlurTrack('bank_account_number');
                            }
                        },
                        model: {
                            value: _setup.bankNumber,
                            callback: function callback($$v) {
                                _setup.bankNumber = $$v;
                            },
                            expression: "bankNumber"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.accountName ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Nombre del titular")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "sureName",
                            "clearable": "",
                            "label": "",
                            "placeholder": "Nombre del titular",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Nombre del titular'
                                }
                            ]
                        },
                        on: {
                            "focus": function($event) {
                                return _setup.onFocusTrack('credit_card_holder_name');
                            },
                            "blur": function($event) {
                                return _setup.onBlurTrack('credit_card_holder_name');
                            }
                        },
                        model: {
                            value: _setup.accountName,
                            callback: function callback($$v) {
                                _setup.accountName = $$v;
                            },
                            expression: "accountName"
                        }
                    })
                ], 1)
            ]),
            _c(_setup.PrivacyDataBox, {
                on: {
                    "popup-click": function($event) {
                        _setup.agreed = true;
                    }
                },
                model: {
                    value: _setup.agreed,
                    callback: function callback($$v) {
                        _setup.agreed = $$v;
                    },
                    expression: "agreed"
                }
            }),
            _c('van-button', {
                staticClass: "submit",
                attrs: {
                    "native-type": "submit"
                }
            }, [
                _vm._v("Siguiente")
            ])
        ], 1),
        _c(_setup.CreditFirstRetainPopup, {
            attrs: {
                "step": 1
            },
            on: {
                "close": function($event) {
                    _setup.isShowFirstRetainPopup = false;
                },
                "show-second": _setup.showSecondRetainPopup
            },
            model: {
                value: _setup.isShowFirstRetainPopup,
                callback: function callback($$v) {
                    _setup.isShowFirstRetainPopup = $$v;
                },
                expression: "isShowFirstRetainPopup"
            }
        }),
        _c(_setup.CreditSecondRetainPopup, {
            on: {
                "close": function($event) {
                    _setup.isShowSecondRetainPopup = false;
                },
                "go-home": _setup.goAppHome
            },
            model: {
                value: _setup.isShowSecondRetainPopup,
                callback: function callback($$v) {
                    _setup.isShowSecondRetainPopup = $$v;
                },
                expression: "isShowSecondRetainPopup"
            }
        })
    ], 1);
};
var staticRenderFns = [
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('div', {
            staticClass: "progress"
        }, [
            _c('img', {
                attrs: {
                    "src": require("@/assets/img/credit/step1.png")
                }
            })
        ]);
    }
];
export { render, staticRenderFns };
